import React from "react"
import { usePage } from "@inertiajs/react"
import { VerticalNavSidebar } from "./vertical-nav-sidebar"
import { InertiaPageHeader } from "./inertia-page-header"

export function InertiaVerticalNavLayout({ children }) {
  const {
    props: { layoutConfig }
  } = usePage()

  const verticalNavVisible = layoutConfig?.components?.verticalNav?.visible

  if (!verticalNavVisible) {
    return (
      <>
        <InertiaPageHeader />
        {children}
      </>
    )
  }

  return (
    <>
      <InertiaPageHeader />
      <div style={{ display: "flex", flex: "1 1 auto" }}>
        <VerticalNavSidebar />
        <div className="flex-1 min-w-0 bg-white rounded-xl mr-3 my-3 p-6 overflow-y-auto max-h-[calc(100vh-24px)]">{children}</div>
      </div>
    </>
  )
}
